import config from 'config';
import { action, autorun, computed, observable } from 'mobx';
// Import viewStore
import ViewStore from 'stores/ViewStore';
// Import API
import API from 'utils/api';

import { getLinkFromChannelTitle, getMetadata, getPreviewImage } from 'utils/helpers';
// Import the MediaContainer Class
import MediaContainer from './MediaContainer';

/**
 * SpecialChannel Class
 */
export default class SpecialChannel {
  // Data loading
  @observable pendingRequestCount = 0;
  @observable teasers             = [];
  @observable sortOption          = '';
  @observable sortOrderAsc        = false;

  /**
   * CONSTRUCTOR
   */
  constructor(sortOption, sortOrderAsc) {
    this.sortOption   = sortOption;
    this.sortOrderAsc = sortOrderAsc;

    autorun(() => {
      const currentViewName = ViewStore.currentViewName;

      if(!this.hasLoadedInitialData && (_.isEqual(currentViewName, 'detail') || _.isEqual(currentViewName, 'overview'))) {
        this.loadTeasers();
      }
    });
  }

  @computed
  get title() {
    const title = this.sortOption || 'noTitle';
    return ViewStore.get(`filter_${title}`);
  }

  @computed
  get hasLoadedInitialData() {
    return this.teasers.length;
  }

  /**
   * ACTIONS
   */
  @action
  loadTeasers() {
    const sortOption   = this.sortOption;
    const sortOrderAsc = this.sortOrderAsc;

    this.pendingRequestCount++;

    const data   = {};
    const sort   = {};

    sort[sortOption] = {
      order: sortOrderAsc
               ? 'asc'
               : 'desc',
    };

    const filter     = [];
    const must = [];

    const nestedQuery = {
      "nested": {
        "path": "links",
        "query": {
          "bool": {
            "filter": [
              {
                "terms": {
                  "links.language": [ViewStore.language]
                }
              }
            ]
          }
        }
      }
    }

    // filter.push(
    //   { terms: { channelId: [this.id] } }
    // );

    must.push( nestedQuery )

    data['query'] = { bool: { filter, must } };

    // filter.push(
    //   { terms: { language: [ViewStore.language] } },
    // );

    data['sort']  = [sort];
    data['query'] = { bool: { filter, must } };
    data['size']  = config.channelPreviewCount + 4;

    if(config.includeAuthToken) {
      data['token'] = API.token;
    }

    API.post('search', { data })
      .then((result) => this.loadTeasersSuccess(result))
      .fail((err) => this.loadError('search 2', err));
  }

  @action
  loadError(request, error) {
    this.pendingRequestCount--;
    console.warn(`loadError ${request}`, error);
  }

  @action
  loadTeasersSuccess(result) {
    let channelMediaContainerIds = [];

    result.hits = _.slice(_.uniqBy(result.hits, 'mediaContainerId'), 0, config.channelPreviewCount);
    this.pendingRequestCount--;

    _.forEach(result.hits, (mc) => {
      const mediaContainer = new MediaContainer(mc);
      this.teasers.push(mediaContainer);
      channelMediaContainerIds.push({
        mediaContainerId: mc.mediaContainerId,
        channelId:        mc.channelId,
      });
    });

    this.deliverThumbs({ channelMediaContainerIds });
  }

  @action
  deliverThumbs(data) {
    this.pendingRequestCount++;

    data['previewImages'] = true;
    data['width']         = 480;

    if(config.includeAuthToken) {
      data['token'] = API.token;
    }

    API.post('deliverThumbs', { data }) // TODO add auth ???
      .then((result) => this.deliverThumbsSuccess(result))
      .fail((err) => this.loadError('deliverThumbs', err));
  }

  @action
  deliverThumbsSuccess(thumbs) {
    this.pendingRequestCount--;
    const thumbsByMc = _.groupBy(thumbs, 'mediaContainerId');

    _.forEach(thumbsByMc, (value, key) => {
      const mcs = _.filter(this.teasers, { id: _.toInteger(key) });
      _.forEach(mcs, (mc) => {
        mc.setThumbnails(value);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/stores/models/SpecialChannel.js